// Abaixo desta largura a barra sempre compacta, mesmo que ela coubesse:
// é o ponto em que os botões largos ficam difíceis de acertar com o dedo.
export const mobileBreakpoint = 768;
// Celular deitado: sobra largura, mas a barra alta come a tela toda.
export const shortScreenBreakpoint = 520;
// Celulares estreitos (iPhone SE e similares).
export const smallMobileBreakpoint = 380;
